/**
 * Highlight the custom-HTML widget that immediately follows any
 * `.mega-menu-item > a` link when…
 *   • the link is hovered (adds `.hover-background`)
 *   • the link’s parent <li> already has `.mega-current-menu-item`
 *       (keeps the highlight for the “current page” in the menu)
 */

document.addEventListener( 'DOMContentLoaded', () => {
  /* ---------- 1. Grab every anchor that’s the *direct* child of a .mega-menu-item <li> ---------- */
  document.querySelectorAll( '.mega-menu-item > a' ).forEach( link => {

    /** The <li> containing this <a> (menu item) **/
    const li = link.closest( '.mega-menu-item' );

    /** The *next* sibling <li> — expected to be the widget container **/
    const widgetLi = li.nextElementSibling;

    /** If there is no next sibling, or it isn’t the custom-HTML widget, skip **/
    if ( !widgetLi || !widgetLi.classList.contains( 'widget_custom_html' ) ) return;

    /* ---------- hover effect ---------- */

    /** When the link gains hover/focus, add the highlight class to the widget **/
    link.addEventListener( 'mouseenter', () => {
      widgetLi.classList.add( 'hover-background' );
    } );
    /** Remove the highlight when the cursor/focus leaves the link **/
    link.addEventListener( 'mouseleave', () => {
      widgetLi.classList.remove( 'hover-background' );
    } );

    /* ---------- current-page (active) effect ---------- */

    /** If this menu item represents the current page,
    keep the widget highlighted from the moment the page loads **/
    if ( li.classList.contains( 'mega-current-menu-item' ) ) {
      widgetLi.classList.add( 'hover-background' );
    }
  } );
} );
